import React, { useState } from 'react'
import Slider from 'react-slick/lib'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { PrevArrow, NextArrow } from '../elements/CarouselArrows'

import '../../styles/scss/components/equote-preview-package-ship-image-carousel.scss'
import VideoSlide from './VideoSlide'

const EQuotePackageCarousel = props => {
  const [activeSlide, setActiveSlide] = useState(0)

  const settings = {
    lazyLoad: 'progressive',
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow {...props} numberOfSlidesToShow={1} isInfinite />,
    nextArrow: <NextArrow {...props} numberOfSlidesToShow={1} isInfinite />,
    // autoplay: props.autoplay
    afterChange: current => setActiveSlide(current)
  }

  return (
    <div className="equote-package-ship-image-slider">
      {props.slides && (
        <Slider {...settings}>
          {props.slides.map((slide, i) => {
            if (slide.type === 'video') {
              return (
                <div
                  key={i}
                  className="equote-brand-preview-carousel-img-container"
                  style={{
                    position: 'relative'
                  }}
                >
                  <VideoSlide slide={slide} isActive={activeSlide === i} />
                </div>
              )
            }

            return (
              <div key={i}>
                <div
                  style={{
                    backgroundImage: `url(${slide.displayImage})`
                  }}
                  className="equote-brand-preview-carousel-img-container"
                >
                  <img
                    className="equote-brand-preview-carousel-img"
                    src={slide.displayImage}
                    alt={slide.marketing_title}
                  />
                  {!props.shouldHideText && (
                    <div className="equote-brand-preview-carousel--text">
                      <h1>{slide.marketing_title}</h1>
                      <p>{slide.marketing_subtitle}</p>
                    </div>
                  )}
                  {!props.shouldHideText &&
                    Boolean(
                      slide.marketing_title.length ||
                        slide.marketing_subtitle.length
                    ) && (
                      <div className="equote-brand-preview-carousel-img--overlay" />
                    )}
                </div>
              </div>
            )
          })}
        </Slider>
      )}
    </div>
  )
}

export default EQuotePackageCarousel
